<template>
<div>
    <!-- page-wrapper Start-->
    <div class="container-fluid p-0">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div>
                <a class="logo">
                  <img
                    class="img-fluid for-light"
                    src="../../assets/images/logo/Logo-DN.png"
                    alt="looginpage"
                  />
                  <img
                    class="img-fluid for-dark"
                    src="../../assets/images/logo/Logo-DN.png"
                    alt="looginpage"
                  />
                </a>
              </div>
              <div v-if="isAdminForm" class="login-main">
                <b-card no-body>
                  <b-tabs pills vertical v-model="tabIndex" @input="onTabChange">
                    <b-tab active>
                      <template #title>
                        <img
                          src="../../assets/images/login/logo-tmi.svg"
                          id="dn1-tooltip"
                        />
                        <span>Darunnajah 1</span>
                      </template>
                      <b-card-text>						  
                        <div v-if="error" class="alert alert-info">
                          <span>{{error}}</span>
                        </div>
						
                        <form class="theme-form" @submit.prevent="handleSubmit">
							            <h4>Sign in to Darunnajah 1</h4>
                          <p>Program Ujian Online v1.0</p>
                          <div class="form-group">
                            <label for="username">Username</label>
                            <input
                              type="text"
                              v-model="username"
                              name="username"
                              class="form-control"
                              :class="{ 'is-invalid': submitted && !username }"
                            />
                            <div
                              v-show="submitted && !username"
                              class="invalid-feedback"
                            >
                              Username is required
                            </div>
                          </div>
                          <div class="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                              type="password"
                              v-model="passwordjwt"
                              name="password"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && !passwordjwt,
                              }"
                            />
                            <div
                              v-show="submitted && !passwordjwt"
                              class="invalid-feedback"
                            >
                              Password is required
                            </div>
                          </div>
                          <div class="form-group mt-3 mb-0">
                            <button
                              class="btn btn-primary btn-block"
                              :disabled="loggingIn"
                            >
                              Login
                            </button>
                          </div>
                          <h6 class="text-muted mt-4 or">Or Sign in with</h6>
                          <div class="social mt-4">
                            <div class="btn-showcase">
                              <a class="btn btn-light" @click="raportTmiLogin">
                                <img
                                  class="img-fluid for-light" width="20px"
                                  src="../../assets/images/logo/Logo-DN.png"
                                  alt="looginpage TMI"
                                />
                                <span> Raport TMI </span>
                              </a>
                              <a class="btn btn-light" @click="raportBpsLogin">                                
                                <img
                                  class="img-fluid for-light" width="20px"
                                  src="../../assets/images/logo/Logo-DN.png"
                                  alt="looginpage BPS"
                                />
                                <span> Raport BPS </span>
                              </a>
                                                      
                            </div>
                          </div>
                          
                          <p class="mt-4 mb-0">
                            
                          </p>
                        </form>
                      </b-card-text>
                    </b-tab>
                    <b-tab>
                      <template #title>
                        <img src="../../assets/images/login/logo-sdi.svg" />
                        <span>SDI</span>
                      </template>
                      <b-card-text>						  
                        <div v-if="error" class="alert alert-info">
                          <span>{{error}}</span>
                        </div>
						
                        <form class="theme-form" @submit.prevent="handleSubmit">
							            <h4>Sign in to SDI Darunnajah</h4>
                          <p>Program Ujian Online v1.0</p>
                          <div class="form-group">
                            <label for="username">Username</label>
                            <input
                              type="text"
                              v-model="username"
                              name="username"
                              class="form-control"
                              :class="{ 'is-invalid': submitted && !username }"
                            />
                            <div
                              v-show="submitted && !username"
                              class="invalid-feedback"
                            >
                              Username is required
                            </div>
                          </div>
                          <div class="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                              type="password"
                              v-model="passwordjwt"
                              name="password"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && !passwordjwt,
                              }"
                            />
                            <div
                              v-show="submitted && !passwordjwt"
                              class="invalid-feedback"
                            >
                              Password is required
                            </div>
                          </div>
                          <div class="form-group mt-3 mb-0">
                            <button
                              class="btn btn-primary btn-block"
                              :disabled="loggingIn"
                            >
                              Login
                            </button>
                          </div>

                          <h6 class="text-muted mt-4 or">Or Sign in with</h6>
                          
                          <div class="social mt-4">
                            <div class="btn-showcase">
                              <a class="btn btn-light" @click="raportSdLogin">
                                <img
                                  class="img-fluid for-light" width="20px"
                                  src="../../assets/images/logo/Logo-DN.png"
                                  alt="looginpage SD"
                                />
                                <span> Raport SD </span>
                              </a>

                              <a class="btn btn-light" @click="raportK13Login">                                
                                <img
                                  class="img-fluid for-light" width="20px"
                                  src="../../assets/images/logo/Logo-DN.png"
                                  alt="looginpage K13"
                                />
                                <span> Raport K13 </span>
                              </a>
                                                      
                            </div>
                          </div>
                          <p class="mt-4 mb-0">
                            
                          </p>
                        </form>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </div>
              <div v-else class="login-main">
                <b-card no-body>
                  <b-tabs pills vertical v-model="tabIndex" @input="onTabChange">
                    <b-tab active>
                      <template #title>
                        <img
                          src="../../assets/images/login/logo-tmi.svg"
                          id="dn1-tooltip"
                        />
                        <span>Darunnajah</span>
                      </template>
                      <b-card-text>						  
                        <div v-if="error" class="alert alert-info">
                          <span>{{error}}</span>
                        </div>
						
                        <form class="theme-form" @submit.prevent="handleSubmit">
							            <h4>Login Siswa</h4>
                          <p>Program Ujian Online v1.0</p>
                          <div class="form-group">
                            <label for="username">Username</label>
                            <input
                              type="text"
                              v-model="username"
                              name="username"
                              class="form-control"
                              :class="{ 'is-invalid': submitted && !username }"
                            />
                            <div
                              v-show="submitted && !username"
                              class="invalid-feedback"
                            >
                              Username is required
                            </div>
                          </div>
                          <div class="form-group">
                            <label htmlFor="password">Password</label>
                            <input
                              type="password"
                              v-model="passwordjwt"
                              name="password"
                              class="form-control"
                              :class="{
                                'is-invalid': submitted && !passwordjwt,
                              }"
                            />
                            <div
                              v-show="submitted && !passwordjwt"
                              class="invalid-feedback"
                            >
                              Password is required
                            </div>
                          </div>
                          <div class="form-group mt-3 mb-0">
                            <button
                              class="btn btn-primary btn-block"
                              :disabled="loggingIn"
                            >
                              Login
                            </button>
                          </div>
                          <p class="mt-4 mb-0">
                            
                          </p>
                        </form>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- latest jquery-->

	<div class="loader" v-if="loader"></div>

  </div>
</template>

<script>
import {url} from "@/urls";
import {service} from '@/services';
import * as _ from 'underscore';
import { validators } from '@/services/validators';
import {helper} from '@/services/helper';

export default {
	data(){
		return {
			formData:{},
			error : "",
			loader:false,
			type: "password",
			email: "test@admin.com",
			password: "test@123456",
			username: "",
			passwordjwt: "",
      submitted: false,
      tabIndex: 1,
      tenant: "siswa"
		}
  },
	mounted(){
		let token = localStorage.getItem("token")
		if (token) {
			this.$router.push({name:'Dashboard'})
		}
	},
	computed: {
		// JWT authentication
		loggingIn() {
			return false;
			//return this.$store.state.authentication.status.loggingIn;
    },
    isAdminForm() {
      return this.$route.name == "LoginAdmin";
    }
	},
	methods:{
    onTabChange() {
      //let listTenant = ["DNPUSAT","DN2","MIDN2","SDI"];
      let listTenant = ["DNPUSAT","SDI"];

      if (this.isAdminForm) { 
        this.tenant = listTenant[this.tabIndex];
      } 
    },
    raportTmiLogin() {
      window.open('https://panji.darunnajah.com/raport-tmi/', '_blank');
    },
    raportSdLogin() {
      window.open('https://panji.darunnajah.com/raport-sd/', '_blank');      
    },
    raportBpsLogin() {
      window.open('https://panji.darunnajah.com/raport-bps/', '_blank');
    },
    raportK13Login() {
      window.open('https://panji.darunnajah.com/raport-k13/', '_blank');
    },
		login(){			
			this.loader = true;
			this.error = validators.loginForm(this.formData);
			if (this.error === '') {
        let body = _.clone(this.formData);
        let loginUrl = this.tenant == "siswa" ? url.auth_siswa_login : url.auth_user_login;
				service.onPost(loginUrl, body)
				.then(result => {
          let userDetail = helper.getUserObject(result.data.user);          
          //console.log(this.tenant, result.data, result.data.token, atob(result.data.user));
          localStorage.setItem("token", result.data.token);
          localStorage.setItem("user", result.data.user);
          localStorage.setItem("idtenant", this.tenant);
          this.$store.commit('user/localTenant', this.tenant)       
          
          if (this.isAdminForm) {
            setTimeout( () => this.$router.push({name:'Dashboard'}), 1000);
          } else {            
            if (!userDetail.status) {
              this.error = "Mohon maaf kamu tidak bdiperkenankan login. Silahkan hubungi panitia ujian."
					    this.loader = false;
            } else {
              setTimeout( () => this.$router.push({name:'DashboardSiswa'}), 1000);
            }            
          }					
				}).catch(error => {
					// eslint-disable-next-line
					console.log(error);
					this.error = "Email or password not matched."
					this.loader = false;
				})
			} else {
				this.loader = false;
			}
		},
		// JWT authentication
		handleSubmit(e) {			
			this.submitted = true;
			const { username, passwordjwt } = this;
			//const { dispatch } = this.$store;
			if (username && passwordjwt) {
				this.formData.username = username;
        this.formData.password = passwordjwt;
        this.formData.idtenant = this.tenant;
				this.login();
				//dispatch("authentication/login", { username, passwordjwt });
			}
		},
		// show/hide password
		showPassword: function () {
			if (this.type === "password") {
				this.type = "text";
			} else {
				this.type = "password";
			}
		},
	}
}
</script>

<style scoped>
@media only screen and (max-width: 768px) {
	/* For mobile phones: */
	.theme-form h4 {
		padding-top: 40px;
	}
}



</style>